import React from "react";
import {
  AdFluid,
  FluidAdSlotType
} from '@insiderintelligence/googleadmanager';

export const FluidAd: React.FC<{ adSlotType: FluidAdSlotType }> = ({adSlotType}) => {
  return (
    <div className="h-fluid-ad md:h-fluid-ad-md lg:h-fluid-ad-lg xl:h-fluid-ad-xl 2xl:h-fluid-ad-2xl">
      <AdFluid adSlotType={adSlotType} />
    </div>
  );
};